module.exports = __webpack_public_path__ + "img/75.5.COD.2cb4a645.png";